import React from "react";

/**
 * @param {*String} text The text you want the option to have.
 * @param {*Function} setter The setter you want to pass down from the calling component to run when clicked.
 * @param {*Any} text The state tied to the setter you are passing down from the calling component.
 * @param {*Object} text The width style object passed down from the mother component.
 * @returns
 */

const OptionButton = ({ text, setter, selected, width, clearError }) => {
  const handleClick = () => {
    clearError();
    setter(!selected);
  };

  return (
    <div style={width} className="h-12 flex items-center mt-4 text-2xl">
      {!selected ? (
        <div
          onClick={handleClick}
          style={{ backgroundColor: "#AFAFAF", borderRadius: "50%" }}
          className="h-8 w-8"
          onKeyDown={() => console.log("getting rid of es-lint error")}
          role="button"
          tabIndex={-1}
        />
      ) : (
        <div
          onClick={() => setter(!selected)}
          style={{ backgroundColor: "#AFAFAF", borderRadius: "50%" }}
          className="h-8 w-8 flex items-center justify-center"
          onKeyDown={() => console.log("getting rid of es-lint error")}
          role="button"
          tabIndex={-1}
        >
          <div
            style={{ backgroundColor: "#0D08E2", borderRadius: "50%" }}
            className="w-5 h-5"
          />
        </div>
      )}
      <p className="pl-2">{text}</p>
    </div>
  );
};

export default OptionButton;
